import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLang } from '@/context/LanguageContext';

const IMG = 'https://images.squarespace-cdn.com/content/v1/63496d45a23c17336a5db13a/';

const tier1 = [
  { name: 'BB Jacques', image: '/photos/artists/bbjacques.jpg' },
  { name: 'Bekar', image: '/photos/artists/bekar.jpg' },
  { name: 'Calogero', image: `${IMG}1666707428314-7PZGYLNWDIEMUEG66SGY/calogero.jpg` },
  { name: 'Clara Ysé', image: '/photos/artists/clara.jpg' },
  { name: 'Disiz La Peste', image: `${IMG}1666707440529-B6MIY9IQ1LGGQ2QGC1X8/disiz-la-peste.jpg` },
  { name: 'Georgio', image: '/photos/artists/georgio.jpg' },
  { name: 'Johnny Jane', image: '/photos/artists/johnny.jpg' },
  { name: 'Juliette Armanet', image: `${IMG}1666707481818-DZYAOR73ORNZ3DC1I1IW/juliette-armanet.jpg` },
  { name: 'Kids Return', image: '/photos/artists/kidsreturn.jpg' },
  { name: "L'Impératrice", image: `${IMG}1666707497562-9QO1RCFDV6QRXZO08KLX/l-imperatrice.jpg` },
  { name: 'Liv Del Estal', image: '/photos/artists/liv.jpg' },
  { name: 'Maëlle', image: '/photos/artists/maelle.jpg' },
  { name: 'Oracle Sisters', image: '/photos/artists/oracle.webp' },
  { name: 'Suzane', image: '/photos/artists/suzane.jpg' },
  { name: 'Yoa', image: '/photos/artists/yoa.jpg' },
  { name: 'Zed Yun Pavarotti', image: '/photos/artists/zed.jpg' },
];

// Extended Tier 1 — additional artists (up to 12), shown above the "Voir tous les artistes" button
const tier1b = [
  { name: 'Billie', image: '/photos/artists/billie.jpg' },
  { name: 'Coline Rio', image: '/photos/artists/colinerio.jpeg' },
  { name: 'Gildaa', image: '/photos/artists/gildaa.jpg' },
  { name: 'Manu Dyens', image: '/photos/artists/manudyens.jpg' },
  { name: 'Marguerite', image: '/photos/artists/marguerite.jpg' },
  { name: 'Marguerite Thiam', image: '/photos/artists/margueritethiam.jpg' },
  { name: 'Matild', image: '/photos/artists/matild.jpg' },
  { name: 'Nesrine Belmokh', image: '/photos/artists/nesrine.jpg' },
  { name: 'Patxi Garat', image: '/photos/artists/patxi.jpg' },
  { name: 'Vicky R', image: '/photos/artists/vickyr.png' },
  { name: 'Yilian Cañizares', image: '/photos/artists/yilian.jpg' },
  { name: 'Zaoui', image: '/photos/artists/zaoui.jpg' },
];

const tier2 = [
  { name: 'Isaac Delusion', image: `${IMG}1666707470666-FK08NT1OWTR8UJCXAX4C/isaac-delusion.jpg` },
  { name: 'Irène Drésel', image: `${IMG}1666707469407-L6EXXIKBX8TNLPTJGEZ6/irene-dresel.jpg` },
  { name: 'Vendredi sur Mer', image: `${IMG}1666707572501-1BQ4OL8S21PZG4KQIN2P/vendredi-sur-mer.jpg` },
  { name: 'Bonnie Banane', image: `${IMG}1666707426753-X7I5U7BCSD7CV05LC5YE/bonnie-banane.jpg` },
  { name: 'French Tobacco', image: `${IMG}1666707453854-YDGNFD82XXLB7TJTUR8B/french-tobacco.jpg` },
  { name: 'Guts', image: `${IMG}1666707460444-QJEVWT8ZTF57KYXD24CA/guts.jpg` },
  { name: 'Montmartre', image: `${IMG}1666707522619-PROYNO5QPBSXM4ROKGJ5/montmartre.jpg` },
  { name: 'RK', image: `${IMG}1666707531126-0Q40GE9KF9VPC3LKZC0O/rk.jpg` },
  { name: 'Nach', image: `${IMG}1666707524338-XI7G2IMS481GPA0O6WL3/nach.jpg` },
  { name: 'LadyLike Lily', image: `${IMG}1666707489092-05C8LLXT624SYI2RP3RX/lady-like-lily.jpg` },
];

const tier3 = [
  { name: 'Lorenzo', image: `${IMG}1666707506767-D5VFOACG5F3FO5520FFE/lorenzo.jpg` },
  { name: 'Lujipeka', image: `${IMG}1666707509921-3PV7MU7B9ASQACS3R51A/lujipeka.jpg` },
  { name: 'Luv Resval', image: `${IMG}1666707513946-AJZJNV7667YP1STKJW52/luv-resval.jpg` },
  { name: 'Møme', image: `${IMG}1666707520414-Q8DBY6EWEERU5SY6L17E/mome.jpg` },
  { name: 'Tim Dup', image: `${IMG}1666707564032-1W4F45HIUVBO1IXDD5SP/tim-dup.jpg` },
  { name: 'Mathilde Fernandez', image: `${IMG}1666707515868-AK0U5RTOMIBH486WWN98/mathilde-fernandez.jpg` },
  { name: 'Max Darmon', image: `${IMG}1666707517279-42PCS7F4DGDMAHXNMLZQ/max-darmon.jpg` },
  { name: 'Savage Toddy', image: `${IMG}1666707541260-O9R6LCYZEOJBUTXNH98D/savage-toddy.jpg` },
  { name: 'La Fine Équipe', image: `${IMG}1666707487817-E6UWZDSTBJM382V7XJ5P/la-fine-equipe.jpg` },
  { name: 'Leslie Medina', image: `${IMG}1666707495232-6GKHD8VW4FWSLUD5Y2ZA/leslie-medina.jpg` },
  { name: 'Lonely Band', image: `${IMG}1666707505148-3E2FVZ03RH5GROX9PBSQ/lonely-band.jpg` },
  { name: 'Retriever', image: `${IMG}1666707529685-VOA10BYSFSSPI0ZRTM4I/retriever.jpg` },
];

const ArtistCard = ({ artist, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-30px' }}
    transition={{ duration: 0.5, delay: Math.min(index * 0.04, 0.4) }}
    className="group relative overflow-hidden rounded-lg aspect-[3/4]"
    data-testid={`artist-card-${artist.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
  >
    <img
      src={artist.image}
      alt={artist.name}
      loading="lazy"
      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
    <div className="absolute bottom-3 left-3 right-3">
      <p className="font-heading font-bold text-white text-sm">{artist.name}</p>
    </div>
  </motion.div>
);

const TrustedArtistsSection = () => {
  const { t } = useLang();
  const [expanded, setExpanded] = useState(false);

  return (
    <section id="artists" data-testid="trusted-artists-section" className="py-24 md:py-32 bg-[#3D2020]">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-16"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4 font-medium">
            {t('artists.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
            {t('artists.title')}
          </h2>
          <p className="text-base md:text-lg text-white/70 leading-relaxed">
            {t('artists.desc')}
          </p>
          <p className="text-sm text-[#E92A3E] font-medium mt-4 leading-relaxed italic">
            {t('artists.names')}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {tier1.map((a, i) => <ArtistCard key={a.name} artist={a} index={i} />)}
        </div>

        {tier1b.length > 0 && (
          <div className="mt-4 md:mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-testid="artists-tier1b">
            {tier1b.map((a, i) => <ArtistCard key={a.name} artist={a} index={i} />)}
          </div>
        )}

        <AnimatePresence>
          {expanded && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.6 }}
              className="overflow-hidden"
            >
              <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
                {tier2.map((a, i) => <ArtistCard key={a.name} artist={a} index={i} />)}
              </div>
              <div className="mt-6 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 md:gap-3">
                {tier3.map((a, i) => <ArtistCard key={a.name} artist={a} index={i} />)}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="flex justify-center mt-10">
          <button
            onClick={() => setExpanded(!expanded)}
            data-testid="view-all-artists-button"
            className="btn-primary rounded flex items-center gap-3"
          >
            {expanded ? t('artists.showLess') : t('artists.viewAll')}
            <ChevronDown size={16} className={`transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TrustedArtistsSection;
